<template>
    <main>
        <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="card bg-secondary shadow border-0">
                <div class="card-header bg-white pb-5">
                    <div class="text-muted text-center mb-3">
                    <small>ข้อมูล</small>
                    </div>
                    <div class="text-center">
                        <p>
                            <img src="https://www.payremind.com/assets/images/team/Pee.jpg" class="rounded img-center img-fluid shadow shadow-lg--hover" style="width: 200px;">
                        </p>
                        <p class="btn-inner--text"><i class="fa fa-id-badge"></i> XSs4SD41D88154785da98gD</p>
                        <a href="#" class="btn btn-danger btn-icon">
                            <span class="btn-inner--icon">
                                <i class="fa fa-refresh"></i>
                            </span>
                            <span class="btn-inner--text">เปลี่ยนบัญชี LINE</span>
                        </a>
                    </div>
                </div>
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                    <small>กรอกข้อมูลเพิ่มเติม ข้อมูลส่วนนี้มีผลต่อใบกำกับภาษี</small>
                    </div>
                    <form role="form">
                    <div class="form-group">
                        <div class="input-group input-group-alternative mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-hat-3"></i></span>
                        </div>
                        <input class="form-control" placeholder="ชื่อ" type="text">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-alternative mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-hat-3"></i></span>
                        </div>
                        <input class="form-control" placeholder="นามสกุล" type="text">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-alternative mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                        </div>
                        <input class="form-control" placeholder="อีเมล" type="email">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                        </div>
                        <input class="form-control" placeholder="Password" type="password">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="ni ni-lock-circle-open"></i></span>
                        </div>
                        <input class="form-control" placeholder="Re-Password" type="password">
                        </div>
                    </div>
                    <!-- <div class="text-muted font-italic">
                        <small>password strength:
                        <span class="text-success font-weight-700">strong</span>
                        </small>
                    </div> -->
                    <div class="row my-4">
                        <div class="col-12">
                        <div class="custom-control custom-control-alternative custom-checkbox">
                            <input class="custom-control-input" id="customCheckRegister" type="checkbox">
                            <label class="custom-control-label" for="customCheckRegister">
                            <span>ฉันยินยอมรับ
                                <a href="#">ข้อตกลง</a>
                            </span>
                            </label>
                        </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <button type="button" class="btn btn-primary mt-4"><i class="fa fa-user-plus"></i> ยืนยันการสมัคร</button>
                    </div>
                    </form>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
    </main>
</template>


<script>

export default {
  name: 'Register',
  components: {
    // HelloWorld
  },
  data(){
      return {
          
      }
  }
}
</script>